export default __webpack_public_path__ + "static/media/map3.697825f5.png";